module.exports = __webpack_public_path__ + "img/result_desk.ed674b78.jpg";